import { Message } from '../components/chat-controls/ChatConversation';
import { MinimalNLSearchRequest, NLWebRequest } from '../models';

/**
 * Initial state for the concierge screen.
 */
export const INITIAL_STATE: MinimalNLSearchRequest = {
    query: '',
    queryHistory: [],
};

/**
 * Filter the messages to only include user queries.
 *
 * @param messages Messages.
 * @returns User queries.
 */
export const onlyUserQueries = (messages: Array<Message>): Array<string> => {
    return messages.filter((m): m is NLWebRequest => 'query' in m).map((m) => m.query);
};

/**
 * Get the location suffix for the concierge screen. If the location is 'your location', return an empty string.
 *
 * @param location The location.
 * @returns The location suffix.
 */
export const getLocationSuffix = (location: string | undefined) => {
    const isGPSPlaceholder = location?.toLowerCase() === 'your location';
    if (isGPSPlaceholder) {
        return '';
    }

    return location ? `in ${location}` : '';
};

const GENERIC_GREETING_WITHOUT_LOCATION_NAME = `Hi there!<br />I’m here to help you discover exciting events. Tell me what you want to do and a location.`;

/**
 * Get the greeting for the concierge screen. If the location is 'your location', return the generic greeting.
 *
 * @param location The location.
 * @returns The greeting.
 */
export const getGreeting = (location: string | undefined) => {
    const isGPSPlaceholder = location?.toLowerCase() === 'your location';

    if (isGPSPlaceholder || !location) {
        return GENERIC_GREETING_WITHOUT_LOCATION_NAME;
    }

    return `Hi there!<br />Tell me what you’d like to do here in ${location} or anywhere else you’d like.`;
};
